import { EntityAdapter, createEntityAdapter, EntityState, Dictionary } from '@ngrx/entity';
import { SceneStatus } from '../../../api/models/scene-status.model';

export const scenesStatusAdapter: EntityAdapter<SceneStatus> = createEntityAdapter<SceneStatus>({
    selectId: (status: SceneStatus) => status.SceneId
});

export interface ScenesStatusState extends EntityState<SceneStatus> {
    ids: number[];
    entities: Dictionary<SceneStatus>;
    loaded: boolean;
}
